export const BREEDS_URL = `/api/v3/breeds/`;
